import { render, staticRenderFns } from "./BookingDaySlots.vue?vue&type=template&id=f8a583ca"
import script from "./BookingDaySlots.vue?vue&type=script&lang=js"
export * from "./BookingDaySlots.vue?vue&type=script&lang=js"
import style0 from "./BookingDaySlots.vue?vue&type=style&index=0&id=f8a583ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports